<style scoped>
  .header {
    margin-bottom: 16px;
  }
  .bill {
    margin-bottom: 15px;
  }
  
</style>
<template>
  <PageContain>
    <v-card
      outlined
      class="header"
    >
      <v-card-title>
        <SearchBar
          v-model="params"
          :fields="search_other_fields"
          cols="12"
          md="3"
        >
          <template v-slot:action>
            <div
              style="display:flex; align-items:center;height:100%"
            >
              <v-btn
                depressed
                color="primary"
                @click="addNew"
              >
                新增
              </v-btn>
            </div>
          </template>
        </SearchBar>
      </v-card-title>
    </v-card>
    <!--   headers={this.table_fields}
                            desserts={this.test} -->
    <PageContain :reserved-height="350">
      <VTable
        :fixed-header-zindex="2"
        fixed-header
        :headers="table_fields"
        :desserts="bills"
        :loading="loading"
      />
    </PageContain>
    <div class="paginate-fix-bottom">
      <VPage
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @pageChange="pageChange"
      />
    </div>
    <EditModal 
      ref="editModal"
      @success="success"
    />
    <DeleteModal 
      ref="deleteModal"
      :del-url="fin_receipt_bill_delete"
      @delSuccess="delSuccess"
    />
  </pagecontain>
</template>
<script route="/fin_bill/fin_receipt_bill">
  import { util_api } from '@/libs/util_api'
  import ReceiptBase from './mixins/receipt_base'
  import BillQueryBase from './mixins/bill_query_base'
  import DelItemBase from './mixins/del_item_base'
  import ReceiptBillCardExpand from './components/receipt_bill_card_expand.vue'
  import EditModal from './components/receipt_bill_card_modal'
  import DeleteModal from './components/delete_modal'
  import VTable from '@/vuetify_custom/v-table/v3'
  import PageContain from '@/views/components/PageContain.vue'
  import UserFlowBase from '@/views/components/flow/user_flow_base';
  import { mapGetters } from 'vuex'
  import {generateFinReceiptBillTransform2AccrualApi} from './service'
  const { fin_receipt_bill_query, fin_receipt_bill_delete } = util_api
  export default {
    components: { EditModal, DeleteModal, VTable, ReceiptBillCardExpand, PageContain },
    mixins: [ BillQueryBase, ReceiptBase, DelItemBase],
    data() {
      this.fin_receipt_bill_delete = fin_receipt_bill_delete
      return {
        flow_nodes: [],
        bill_query_path: fin_receipt_bill_query,
      }
    },
    computed: {
      ...mapGetters('async', ['banks', 'receipt_purposes']),
      is_accounting_manager() {
        const current_hash = this.$store.state.hash_authority || {}
        return current_hash['sk_is_accounting_manager']
      },
      table_fields() {
        const _this = this
        return [
          {
            expand:true,
            z_index:1,
            renderv: (h, _, params) => {
              return h(ReceiptBillCardExpand, {
                props: {
                  value: params
                }
              })
            }
          },
          {
            text: 'uid',
            value: 'uid',
            width: 160,
            renderv: (h, _, params) => {
              const ret = [['div', {}, params.uid]]
            
              if (params.del) {
                ret[0][1].class = 'color-error'
                ret.push(['span', {
                  class:'color-error'
                }, '[已废弃]'])
              }
              if (params.receipt_list && params.receipt_list.length) {
                ret.push(['span', {
                  class:'color-info',
                  style: 'cursor: pointer;',
                  on: {
                    click:() => {
                      // _this.$util.receiptUrl(expense_group.receipt.filename)
                      params.receipt_list.map(receipt => {
                        window.open(_this.$util.receiptUrl(receipt.filename), '__blank')
                      })
                    }
                  }
                }, '[银行回单]'])
              }
              return h('div', ret.map(i => h(...i)))
            }
          },
          {
            text: '单据名称',
            value: 'name',
            // width: 200,
          },
          // {
          //   text: '单据类型',
          //   value: 'bill_type',
          //   type: 'list_field',
          //   items: receipt_types,
          //   item_key: 'uid',
          //   item_text: 'name',
          //   width: 130,
          // },
          // {
          //   text: '收款用途编号',
          //   value: 'purpose_uid',
          //   type: 'list_field',
          //   item_text: 'name',
          //   item_key: 'kingdee_uid',
          //   items: this.receipt_purposes,
          //   width: 130,
          // },
          {
            text: '公司',
            value: 'company_id',
            type: 'company_field',
            width: 120,
          },
          {
            text: '填写人',
            value: 'fill_user_id',
            type: 'customer_field',
            width: 120,
          },
          // {
          //   text: '收款银行',
          //   value: 'receipt_bank_id',
          //   type: 'list_field',
          //   items: this.banks,
          //   item_text: 'bank',
          //   item_key: 'id',
          //   width: 150,
          // },
          {
            text: '付款银行名称',
            value: 'opposite_bank_name',
            width: 150,
          },
          // {
          //   text: '付款银行账号',
          //   value: 'opposite_bank_number',
          //   width: 150,
          // },
          // {
          //   text: '付款银行账户名',
          //   value: 'opposite_account',
          //   width: 150,
          // },
          // {
          //   text: '往来单位类型',
          //   value: 'contact_unit_type',
          //   type: 'list_field',
          //   items: unit_types,
          //   item_text: 'name',
          //   item_key: 'uid',
          //   width: 150,
          // },
          // {
          //   text: '来往单位',
          //   value: 'contact_unit_name',
          //   width: 150,
          // },
          {
            text: '收款金额',
            value: 'total_amount',
            type: 'money_field',
            width: 150,
            // value_key: 'id',
            // currency_type_key: 'currency',
          },
          // {
          //   text: '业务日期',
          //   value: 'handled_at',
          //   type: 'date_field',
          //   width: 150,
          // },
          // {
          //   text: '备注',
          //   key: 'remark',
          //   type: 'text_field',
          //   width: 150,
          // },
          {
            text: '状态',
            width: 180,
            value: 'status',
            align: 'center',
            // fixed: 'right',
            renderv: (h, _, row) => {
            
              const user_flow = row.user_flow;
              const ret = []
              
              if (user_flow) {
                ret.push(h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    title: row.name
                  }
                }))
                ret.push(h('div', {
                  style: {
                    textAlign: 'left',
                    color: row.e_file_audit ? 'green' : ''
                  }
                }, row.e_file_audit ? '已经电子件审核' : ''))
              } else {
                ret.push(h('div', '-'))
              }
              return h('div', {}, ret)
            }
          },
     
          {
            text: '操作',
            align: 'center',
            value: 'index',
            b_text: '操作',
            type: 'button_s_field',
            width: 120,
            z_index:1,
            fixed: 'right',
            callBack:({key}, target) => {
              this[key] && this[key](target)
             
            },
            //  @edit="edit"
            // @copy="copy"
            // @del="deleteCard"
            buttons: [
              {
                text: '编辑',
                key: 'editProxy'
              },
              {
                text: '生成收款计提单',
                key: 'generate'
              },
              {
                text: '复制',
                key: 'copy'
              },
              {
                text: '废弃',
                key: 'deleteCard'
              }
            ]  
          }
        ]
      }
    },
    created() {
      this.getFlowInfo()
    },
    mounted() {
      //
    },
    methods: {
      editProxy(params) {
        if (params.user_flow && params.user_flow.is_finish && !this.is_accounting_manager) {
          this.$vModal.warning({
            title: '提示',
            content: '审核完成后不能修改！'
          })
          return 
        }
      
        this.edit(params)
      },
      generate(params) {
        this.$vModal.confirm({
          title: '提示',
          content: `确定将收款单${params.uid}生成收款计提单?`,
          loading: true,
          onOk:({
            destroy,
            stopLoading
          }) => {
            generateFinReceiptBillTransform2AccrualApi({id:params.id}).then(() => {
              this.query()
              this.$Message.success('成功生成收款计提单！')
              window.open('/fin_bill/fin_receipt_accrual_bill', '__blank')

              destroy()
            }).finally(() => {
              stopLoading()
            })
          }
        })
      },
      getFlowInfo() {
       
        this.$util.ajax.get(this.$util.api.get_flow_by_link_model, {
          params: {
            link_model: 'FinReceiptBill'
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            data.nodes.forEach((node) => {
              this.flow_nodes.push(node);
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
    }
  }
</script>
